import React, { useMemo } from "react";
import Navbar from "../Navbar";
import Footer from "../Footer";
import useThemeMode from "../../hooks/useThemeMode";
import { getMarketingTheme } from "../../utils/marketingTheme";

function MarketingPageShell({ children, showFooter = true }) {
  const { isDark } = useThemeMode();
  const colors = useMemo(() => getMarketingTheme(isDark), [isDark]);

  return (
    <div
      style={{
        background: colors.pageBg,
        backgroundImage: colors.pageGradient,
        minHeight: "100vh"
      }}
    >
      <Navbar />
      {children}
      {showFooter ? <Footer /> : null}
    </div>
  );
}

export default MarketingPageShell;